'use strict';

module.exports = {
  timeFlexibleAggregations: [
    'salesMAT',
    'forecastSales',
    'promoShare',
    'salesImpactMAT',
    'regularSalesImpact',
    'totalCostImpact',
    'regularCostImpact',
    'marginProposed',
    'marginDelta',
    'marginLive',
    'economicTension',
    'competitorTension',
    'architectureTension',
    'storeGroupTension',
    'competitor1LiveDistance',
    'competitor1ProposedDistance',
    'competitor1DeltaVsPrev',
    'competitor2LiveDistance',
    'competitor2ProposedDistance',
    'competitor2DeltaVsPrev',
    'competitor1LiveDistanceVolume',
    'competitor1ProposedDistanceVolume',
    'competitor1DeltaVsPrevVolume',
    'competitor2LiveDistanceVolume',
    'competitor2ProposedDistanceVolume',
    'competitor2DeltaVsPrevVolume',
  ],
  timeFlexibleIndependentAggregations: [
    'numPriceChanges',
    'totalImpactInYear',
    'regularImpactInYear',
    'costImpactInYear',
    'regularCostImpactInYear',
    'competitor1LiveDistancePrice',
    'competitor1ProposedDistancePrice',
    'competitor1DeltaVsPrevPrice',
    'competitor2LiveDistancePrice',
    'competitor2ProposedDistancePrice',
    'competitor2DeltaVsPrevPrice',
  ],
  timeFlexibleGridViewFields: [
    'yearlySales',
    'yearlyVolume',
    'scenarioCostImpact',
    'regularCostImpact',
    'scenarioSalesImpact',
    'regularSalesImpact',
  ],
  timeFlexibleIndependentGridViewFields: [
    '_id',
    'workpackageId',
    'toolStoreGroupKey',
    'hierarchy',
    'intentionMargin',
    'liveMargin',
    'currentPromotion',
    'hasUpcomingPromotion',
    'upcomingPromotion',
    'childPromotions',
    'costDelta',
    'costDeltaPerContentUnit',
    'costDeltaPerNormWeight',
    'livePrice',
    'intentionPrice',
    'productKey',
    'productKeyDisplay',
    'clientProductKey',
    'scenarioKey',
    'alerts',
    'architectureReferencePrice',
    'competitorPrices',
    'competitorReferencePrice',
    'economicReferencePrice',
    'intentionCost',
    'isOnPromotion',
    'liveCost',
    'priceHistoryWeek',
    'productDescription',
    'productSizeType',
    'scenarioPrice',
    'scenarioPriceChange',
    'scenarioPriceChangeRatio',
    'vatRate',
    'weightValue',
    'brandName',
    'contentValue',
    'toolStoreGroupDescription',
    'competitors',
    'optimizedPrice',
    'overridePrice',
    'transitionPeriodOverrideMetadata',
    'scenarioMargin',
    'scenarioPriceChangePerContentUnit',
    'scenarioPriceChangeRatioPerContentUnit',
    'scenarioPricePerContentUnit',
    'storeGroupReferencePrice',
    'minMaxReferencePrice',
    'vatCalc',
    'alertCounts',
    'mandatoryEngineInputs',
    'nonPromoNetCost',
    'nonPromoNetCostPerContentUnit',
    'nonPromoNetCostPerNormWeight',
    'intentionCostPerNormWeight',
    'intentionPricePerNormWeight',
    'liveCostPerNormWeight',
    'livePricePerNormWeight',
    'intentionCostPerContentUnit',
    'intentionPricePerContentUnit',
    'liveCostPerContentUnit',
    'livePricePerContentUnit',
    'scenarioPricePerNormWeight',
    'scenarioPriceChangePerNormWeight',
    'scenarioPriceChangeRatioPerNormWeight',
    'competitor1',
    'competitor2',
    'architectureGroupPriority',
    'filteredAlerts',
    'normWeight',
    'normWeightUnitOfMeasure',
    'inferredGoLiveDate',
    'inferredGoLivePrice',
    // Required for Architecture Grouping (sortBySubGroupAndLPG)
    'subGroupDescription',
    'subGroupValues',
    'linePricingGroupDescription',
    'hasUnsavedKpiResults',
    'hasPriceChanged',
    'attributes',
    'forecastVolume',
    'forecastSales',
    'staticForecastVolume',
    'strategicForecastVolume',
    'strategicPrice',
    'crossElasticityVolume',
    'crossElasticityPrice',
    'distributionByAssortmentRole',
    'similarityGroupKey',
    'similarityGroupDescription',
    'cannGroupId',
    'cannGroupName',
    'lastEngineSource', // used to calculate referencePriceAtOverride
    'referenceDateCost',
    'referenceDatePrice',
  ],
  additionalCostFields: [
    'referenceDateTransferPrice',
    'referenceDatePurchasePrice',
    'livePurchasePrice',
    'livePurchasePricePerNormWeight',
    'livePurchasePricePerContentUnit',
    'intentionPurchasePrice',
    'intentionPurchasePricePerNormWeight',
    'intentionPurchasePricePerContentUnit',
    'liveTransferPrice',
    'liveTransferPricePerNormWeight',
    'liveTransferPricePerContentUnit',
    'intentionTransferPrice',
    'intentionTransferPricePerNormWeight',
    'intentionTransferPricePerContentUnit',
    'purchasePriceDelta',
    'purchasePriceDeltaPerNormWeight',
    'purchasePriceDeltaPerContentUnit',
    'transferPriceDelta',
    'transferPriceDeltaPerNormWeight',
    'transferPriceDeltaPerContentUnit',
  ],
};
